import React from 'react';

import { useSettings } from 'app/main/components';
import DetailsSectionStats, { type StatType } from 'app/main/modules/components/DetailsSectionStats';

interface ProjectsDetailsSectionStatsGeneralProps {
	stats?: any;
}

export default function ProjectsDetailsSectionStatsGeneral(props: ProjectsDetailsSectionStatsGeneralProps) {
	const { t } = useSettings();

	const stats: StatType[][] = [
		[
			{ name: t('PROJ_SECTION_BILLING_STATS_VALUE_PLANNED'), value: props.stats?.proj_value_planned },
			{
				name: t('PROJ_SECTION_BILLING_STATS_VALUE_FINAL'),
				value: props.stats?.proj_value_billed,
				percent: props.stats?.proj_value_billed_percent
			},
			{
				name: t('PROJ_SECTION_BILLING_STATS_VALUE_MISSING'),
				value: props.stats?.proj_value_missing,
				percent: props.stats?.proj_value_missing_percent
			}
		],
		[
			{ name: t('PROJ_SECTION_BILLING_STATS_EXPENSES_TOTAL'), value: props.stats?.proj_expenses_total },
			{
				classes: { name: 'pl-16' },
				name: t('PROJ_SECTION_BILLING_STATS_EXPENSES_INVOICES'),
				value: props.stats?.proj_expenses_invoices
			},
			{
				classes: { name: 'pl-16' },
				name: t('PROJ_SECTION_BILLING_STATS_EXPENSES_WORKREPORTS'),
				value: props.stats?.proj_expenses_workreports
			}
			// {
			// 	classes: { name: 'pl-16' },
			// 	name: t('PROJ_SECTION_BILLING_STATS_EXPENSES_OTHER'),
			// 	value: props.stats?.proj_expenses_other
			// }
		],
		[
			{
				name: t('PROJ_SECTION_BILLING_STATS_PROFIT_PLANNED'),
				value: props.stats?.proj_profit_planned,
				percent: props.stats?.proj_profit_planned_percent
			},
			{
				name: t('PROJ_SECTION_BILLING_STATS_PROFIT_FINAL'),
				value: props.stats?.proj_profit_billed,
				percent: props.stats?.proj_profit_billed_percent,
				color: props.stats?.proj_profit_billed_percent > 0 ? 'success.main' : 'error.main'
			}
		]
	];

	return <DetailsSectionStats title={t('PROJ_SECTION_BILLING_STATS_TITLE')} stats={stats} />;
}
